module.exports = __webpack_public_path__ + "static/img/5.949b875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Multiriesgo-corporativo/5.png
// module id = z+QF
// module chunks = 0